import { action } from 'satcheljs';
import NudgedRow from '../store/schema/NudgedRow';
import { TableView } from 'owa-mail-list-store';

export const onGetNudgesCompleted = action(
    'ON_GET_NUDGES_COMPLETED',
    (nudgedRows: NudgedRow[], tableView: TableView) => ({
        nudgedRows,
        tableView,
    })
);
